import React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Link } from "react-router-dom";

export default props => {
    return (
        <div style={{ width: "100%", margin: "10px auto 10px auto" }}>
            <FormControl style={{ width: "100%" }} required={props.required}>
                <InputLabel id="demo-simple-select-label">{props.text}</InputLabel>
                {props.treatments.length === 0 ? (
                    <Select labelId="newTreatmentSelect" id="newTreatmentSelect">
                        <Link
                            key="childkey"
                            style={{ width: "100%" }}
                            to={{
                                pathname: "/Treatments"
                            }}>
                            <MenuItem>Ny behandling</MenuItem>
                        </Link>
                    </Select>
                ) : (
                    <Select
                        labelId="treatmentSelect"
                        id="treatmentSelect"
                        data-testid="treatment-selector"
                        onChange={async event => await props.changeValue(event.target.value)}>
                        {props.treatments.map((treatment, index) => (
                            <MenuItem value={treatment.id}>{treatment.name}</MenuItem>
                        ))}
                    </Select>
                )}
            </FormControl>
        </div>
    );
};
